export default __webpack_public_path__ + "static/media/hippie_graphics_01_text_01.9bb0ffff.svg";